export default __webpack_public_path__ + "static/media/12.8cee3811.webp";